const deleteModalLocationTypes = {
    DOCUMENT: 'DOCUMENT',
    CASE: 'CASE',
    INVOICE_LINE: 'INVOICE_LINE',
    INVOICE: 'INVOICE',
};

export default deleteModalLocationTypes;
